export enum RoomTypes {
  All = 1,
  Favorite = 2,
  Recent = 3,
  eTMF = 4,
  SSU = 5,
  Collaborate = 6,
  General = 8,
}
